import { FC } from "react";

import classes from "./BattleResult.module.css";
import { BattleModelDocument } from "../image/Image";
import { useSelector } from "react-redux";
import { userState } from "../../store/user";
import { getLang, i18n } from "../../i18n";

interface Props {
  currentUserIndex: number;
  _id: string;
  battleID: BattleModelDocument;
  deleteNotification: (id: string) => Promise<void>;
  setPopupImage: React.Dispatch<React.SetStateAction<string>>;
}

const BattleLose: FC<Props> = ({
  currentUserIndex,
  _id,
  battleID,
  deleteNotification,
  setPopupImage,
}) => {
  const lang = getLang();
  const t = i18n.battleLose[lang];

  const user = useSelector(userState);
  let loseAmount = 0;
  switch (battleID.level) {
    case 1:
      loseAmount = 0;
      break;
    case 2:
      loseAmount = 10;
      break;
    case 3:
      loseAmount = 25;
      break;
    case 4:
      loseAmount = 50;
      break;
    case 5:
      loseAmount = 90;
      break;
    case 6:
      loseAmount = 150;
      break;
    case 7:
      loseAmount = 250;
      break;
  }
  return (
    <div
      className={`${classes.votepair} ${classes.isResult} ${classes.resultLose}`}
    >
      <div
        className={classes.delete}
        onClick={() => {
          deleteNotification(_id);
        }}
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23 23" fill="none">
          <path
            d="M16.2353 6.76471L6.76471 16.2353M6.76471 6.76471L16.2353 16.2353"
            stroke="#50A7EA"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
        </svg>
      </div>

      <div className={classes.images}>
        {/* Artwork 1 */}
        <div
          className={`${classes.img} ${
            battleID.user1ID === user._id ? classes.voted : ""
          }`}
          onClick={() => {
            if (currentUserIndex === 1)
              setPopupImage(battleID.artwork1ID || "");
          }}
        >
          {battleID.user1ID !== user._id && (
            <span className={classes.popupIcon}>
              {/* Popup icon SVG */}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fillRule="evenodd"
                clipRule="evenodd"
                viewBox="0 0 509 511.54"
              >
                <path
                  fillRule="nonzero"
                  fill="#fff"
                  d="M447.19 347.03c0-17.06 13.85-30.91 30.91-30.91 17.05 0 30.9 13.85 30.9 30.91v87.82c0 21.08-8.63 40.29-22.51 54.18-13.88 13.88-33.09 22.51-54.18 22.51H76.69c-21.09 0-40.3-8.63-54.18-22.51C8.63 475.14 0 455.93 0 434.85V76.69c0-21.09 8.63-40.3 22.51-54.18C36.39 8.63 55.6 0 76.69 0h86.98c17.06 0 30.9 13.85 30.9 30.9 0 17.06-13.84 30.91-30.9 30.91H76.69c-4.07 0-7.82 1.69-10.51 4.37-2.68 2.69-4.37 6.44-4.37 10.51v358.16c0 4.06 1.69 7.82 4.37 10.5 2.69 2.68 6.44 4.38 10.51 4.38h355.62c4.07 0 7.82-1.7 10.51-4.38 2.68-2.68 4.37-6.44 4.37-10.5v-87.82zm0-243.56L308.15 244.28c-11.91 12.12-31.45 12.28-43.56.37-12.11-11.91-12.28-31.45-.37-43.56L401.77 61.81H309.7c-17.06 0-30.9-13.85-30.9-30.91 0-17.05 13.84-30.9 30.9-30.9h168.4C495.15 0 509 13.85 509 30.9v165.04c0 17.06-13.85 30.9-30.9 30.9-17.06 0-30.91-13.84-30.91-30.9v-92.47z"
                />
              </svg>
            </span>
          )}
          <img src={battleID.artwork1Src} alt="" />
          <div
            className={`${classes.score} ${
              battleID.artwork1VotesCount > battleID.artwork2VotesCount
                ? classes.win
                : classes.lose
            }`}
          >
            {battleID.artwork1VotesCount}
          </div>
        </div>

        {/* Artwork 2 */}
        <div
          className={`${classes.img} ${
            battleID.user2ID === user._id ? classes.voted : ""
          }`}
          onClick={() => {
            if (currentUserIndex === 0)
              setPopupImage(battleID.artwork2ID || "");
          }}
        >
          {battleID.user2ID !== user._id && (
            <span className={classes.popupIcon}>
              {/* Popup icon SVG */}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fillRule="evenodd"
                clipRule="evenodd"
                viewBox="0 0 509 511.54"
              >
                <path
                  fillRule="nonzero"
                  fill="#fff"
                  d="M447.19 347.03c0-17.06 13.85-30.91 30.91-30.91 17.05 0 30.9 13.85 30.9 30.91v87.82c0 21.08-8.63 40.29-22.51 54.18-13.88 13.88-33.09 22.51-54.18 22.51H76.69c-21.09 0-40.3-8.63-54.18-22.51C8.63 475.14 0 455.93 0 434.85V76.69c0-21.09 8.63-40.3 22.51-54.18C36.39 8.63 55.6 0 76.69 0h86.98c17.06 0 30.9 13.85 30.9 30.9 0 17.06-13.84 30.91-30.9 30.91H76.69c-4.07 0-7.82 1.69-10.51 4.37-2.68 2.69-4.37 6.44-4.37 10.51v358.16c0 4.06 1.69 7.82 4.37 10.5 2.69 2.68 6.44 4.38 10.51 4.38h355.62c4.07 0 7.82-1.7 10.51-4.38 2.68-2.68 4.37-6.44 4.37-10.5v-87.82zm0-243.56L308.15 244.28c-11.91 12.12-31.45 12.28-43.56.37-12.11-11.91-12.28-31.45-.37-43.56L401.77 61.81H309.7c-17.06 0-30.9-13.85-30.9-30.91 0-17.05 13.84-30.9 30.9-30.9h168.4C495.15 0 509 13.85 509 30.9v165.04c0 17.06-13.85 30.9-30.9 30.9-17.06 0-30.91-13.84-30.91-30.9v-92.47z"
                />
              </svg>
            </span>
          )}
          <img src={battleID.artwork2Src} alt="" />
          <div
            className={`${classes.score} ${
              battleID.artwork2VotesCount > battleID.artwork1VotesCount
                ? classes.win
                : classes.lose
            }`}
          >
            {battleID.artwork2VotesCount}
          </div>
        </div>
      </div>

      {/* Results */}
      <div className={`${classes.results} ${classes.resultLose}`}>
        <div>
          <div className={classes.title}>{battleID.topic.title}</div>
          <div className={classes.battleLevel}>
            {t.level} <span className={classes.levelNum}>{battleID.level}</span>
          </div>
        </div>
        <div className={classes.loseLabel}>
          <span>{t.youLose}</span>
          {battleID.level > 1 && (
            <span className={classes.losePayment}>+{loseAmount} 🌕</span>
          )}
        </div>
      </div>
    </div>
  );
};

export default BattleLose;
